import { CleaningCategories, DropdownOption, ExtraService, OfferedServices } from '@/components/BookingApp/interfaces';

export const fetchCleaningCategories = async (): Promise<CleaningCategories> => {
  try {
    const response = await fetch('/api/cleaning-categories')
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }
    return response.json()
  } catch (error) {
    console.error('Error fetching cleaning categories:', error)
    throw error
  }
};

export const fetchOfferedServices = async (category?: string): Promise<OfferedServices> => {
  try {
    let url = '/api/offered-services';
    if (category) {
      url += `?cleaning_category=${encodeURIComponent(category)}`;
    }
    const response = await fetch(url)
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }
    return response.json()
  } catch (error) {
    console.error('Error fetching cleaning categories:', error)
    throw error
  }
};

export const fetchSqftOptions = async (): Promise<DropdownOption[]> => {
  try {
    const response = await fetch('/api/sqft-options')
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }
    return response.json()
  } catch (error) {
    console.error('Error fetching sqft options:', error)
    throw error
  }
};

export const getPricesForProperty = async (data: Record<string, any>): Promise<any> => {
  try {
    const response = await fetch('/api/property-prices', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return response.json();
  } catch (error) {
    console.error('Error sending data:', error);
    throw error;
  }
};

export const fetchExtraServices = async (square_feet: string, category?: string): Promise<ExtraService[]> => {
  try {
    let url = '/api/extras?square_feet=' + square_feet;
    if (category) {
      url += `&cleaning_category=${encodeURIComponent(category)}`;
    }
    const response = await fetch(url)
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }
    return response.json()

  } catch (error) {
    console.error('Error fetching extras:', error)
    throw error
  }

};

const createOrUpdate = async (resource: string, args: Record<string, any>): Promise<any> => {
  const id = args.id;
  delete(args.id);
  let url = '/api/' + resource;
  if (id) {
    url += '/' + id;
  }
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(args),
  });

  return response.json();
};

export const createOrUpdateClient = async (args: Record<string, any>): Promise<any> => {
  return createOrUpdate("clients", args);
};

export const createOrUpdateNote = async (args: Record<string, any>): Promise<any> => {
  return createOrUpdate("notes", args);
};

export const createOrUpdateProperty = async (args: Record<string, any>): Promise<any> => {
  return createOrUpdate("properties", args);
};

export const getProperty = async (propertyId: number): Promise<any> => {
  const response = await fetch('/api/properties/' + propertyId, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    }
  });

  return response.json();
};

export const requestBooking = async (args: Record<string, any>): Promise<any> => {
  const response = await fetch('/api/bookings', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(args),
  });

  return response.json();
};

export const fetchLocations = async (): Promise<{}> => {
  try {
    const response = await fetch('/api/locations')
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }
    return response.json()
  } catch (error) {
    console.error('Error fetching locations:', error);
    throw error;
  }
};
